import styles from './ProductChip.module.css'

/**
 * ProductChip — pill showing a product a knowledge source is associated with.
 * Products have no category to key a color off, so all chips share one neutral
 * treatment (unlike the per-type coloring skills carried).
 *
 * Props:
 *   name     {string}
 *   onRemove {function} — optional; renders a small × button if provided
 */
export default function ProductChip({ name, onRemove }) {
  return (
    <span className={styles.chip}>
      <span className={styles.name}>{name}</span>
      {onRemove && (
        <button
          type="button"
          className={styles.remove}
          onClick={onRemove}
          aria-label={`Remove product ${name}`}
        >
          ×
        </button>
      )}
    </span>
  )
}
